import { z } from "zod";

export const productEmailTypeSchema = z
  .enum(["FULFILLMENT"])
  .describe("ProductEmailType");

export const productEmailSchema = z
  .object({
    id: z.uuid(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
    type: productEmailTypeSchema,
    header: z.string().max(512),
    message: z.string().nullable(),
    buttonText: z.string().max(255).nullable(),
    buttonLink: z.string().max(512).nullable(),
    productId: z.uuid(),
    variantId: z.uuid().nullable(),
    optionValueId: z.uuid().nullable(),
  })
  .describe("ProductEmail");

export const createProductEmailSchema = z
  .object({
    type: productEmailTypeSchema,
    header: z.string().min(1).max(512),
    message: z.string().optional(),
    buttonText: z.string().max(255).optional(),
    buttonLink: z.string().max(512).optional(),
    productId: z.uuid(),
    variantId: z.uuid().optional(),
    optionValueId: z.uuid().optional(),
  })
  .describe("CreateProductEmail");

export const updateProductEmailSchema = z
  .object({
    type: productEmailTypeSchema.optional(),
    header: z.string().min(1).max(512).optional(),
    message: z.string().optional(),
    buttonText: z.string().max(255).optional(),
    buttonLink: z.string().max(512).optional(),
    variantId: z.uuid().nullish(),
    optionValueId: z.uuid().nullish(),
  })
  .describe("UpdateProductEmail");

export const productEmailFiltersSchema = z
  .object({
    productId: z.uuid().optional(),
    variantId: z.uuid().optional(),
    optionValueId: z.uuid().optional(),
    type: productEmailTypeSchema.optional(),
  })
  .describe("ProductEmailFilters");

export const productEmailFormBaseSchema = z
  .object({
    header: z.string(),
    message: z.string().optional(),
    buttonText: z.string().optional(),
    buttonLink: z.string().optional(),
  })
  .describe("ProductEmailFormBase");

export const productEmailFormSchema = productEmailFormBaseSchema
  .superRefine((data, ctx) => {
    if (!data.header || data.header.trim().length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Email header is required",
        path: ["header"],
      });
    }
  })
  .describe("ProductEmailForm");
